import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["uploadForm", "uploadButton"]

  uploadImage(event) {
    event.preventDefault()

    const form = this.uploadFormTarget
    const formData = new FormData(form)
    const csrfToken = form.querySelector('meta[name="csrf-token"]')?.content

    // Disable button during upload
    this.uploadButtonTarget.disabled = true
    this.uploadButtonTarget.textContent = 'Uploading...'

    fetch(form.action, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken
      },
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.url) {
        // Trigger custom event with image data
        this.dispatchImageSelected(data.url, data.id)
        this.closeModal()
      } else if (data.error) {
        alert(`Upload failed: ${data.error}`)
        this.uploadButtonTarget.disabled = false
        this.uploadButtonTarget.textContent = 'Upload'
      }
    })
    .catch(error => {
      console.error('Upload error:', error)
      alert('An error occurred while uploading the image.')
      this.uploadButtonTarget.disabled = false
      this.uploadButtonTarget.textContent = 'Upload'
    })
  }

  selectImage(event) {
    const card = event.currentTarget
    const imageUrl = card.dataset.imageUrl
    const imageId = card.dataset.imageId

    if (imageUrl) {
      this.dispatchImageSelected(imageUrl, imageId)
      this.closeModal()
    }
  }

  dispatchImageSelected(url, id) {
    // Dispatch custom event that TinyMCE will listen to
    const event = new CustomEvent('tinymce:imageSelected', {
      detail: { url, id },
      bubbles: true
    })
    window.dispatchEvent(event)
  }

  closeModal() {
    const modalElement = document.querySelector('#modalWindow')
    if (modalElement) {
      const modal = Modal.getInstance(modalElement)
      if (modal) {
        modal.hide()
      }
    }
  }
}
